<template>
    <v-container style="width: 80%; padding-top: 7%;" class="text-left">
      <sub class="header mb-7">ORIENTAMOS NUESTROS SERVICIOS A</sub>
      <v-card
        elevation="0"
        class="px-5 py-5 mb-5"
        v-for="item in content"
        color="#F5F5F5"
      >
        <h5 class="number">{{item.id}}</h5>
        <body-1 class="body">{{item.body}}</body-1>
      </v-card>
    </v-container>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      content: [
        {
          id: "1",
          body: "Empresas generadoras",
        },
        {
          id: "2",
          body: "Empresas comercializadoras mayoristas",
        },
        {
          id: "3",
          body: "Inversionistas en generación",
        },
        {
          id: "4",
          body: "Banca de Inversión",
        },
        {
          id: "5",
          body: "Empresas aseguradoras",
        },
      ],
    }
  },
}
</script>

<style>

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.body {
  color: #161c2d;
}

.header {
  font-weight: 400;
  font-size: 1.7rem;
  line-height: 2rem;
  color: #161c2d;
}

.number {
  font-weight: 400;
  font-size: 2rem;
  color: #00838f;
}

</style>



// WEBPACK FOOTER //
// src/components/ClientsXSmall.vue